const getIcon = (symbol) => {
  if (!symbol) {
    return require("../assets/crypto/other.png").default;
  }
  if (symbol === "USDC/ODOP") {
    return require("../assets/crypto/odop.png").default;
  }
  if (symbol?.includes("/")) {
    symbol = symbol.split("/")[0];
  }
  switch (symbol) {
    // Crypto
    case "BTC":
      return require("../assets/crypto/btc.png").default;
    case "ETH":
      return require("../assets/crypto/eth.png").default;
    case "LINK":
      return require("../assets/crypto/link.png").default;
    case "ETC":
      return require("../assets/crypto/etc.png").default;
    case "EOS":
      return require("../assets/crypto/eos.png").default;
    case "LTC":
      return require("../assets/crypto/ltc.png").default;
    case "BCH":
      return require("../assets/crypto/bch.png").default;
    case "BNB":
      return require("../assets/crypto/bnb.png").default;
    case "BSV":
      return require("../assets/crypto/bsv.png").default;
    case "XTZ":
      return require("../assets/crypto/xtz.png").default;
    case "XRP":
      return require("../assets/crypto/xrp.png").default;
    case "ALGO":
      return require("../assets/crypto/algo.png").default;
    case "MATIC":
      return require("../assets/crypto/matic.png").default;
    case "OKB":
      return require("../assets/crypto/okb.png").default;
    case "HT":
      return require("../assets/crypto/ht.png").default;
    case "ATOM":
      return require("../assets/crypto/atom.png").default;
    case "TRX":
      return require("../assets/crypto/trx.png").default;
    case "ADA":
      return require("../assets/crypto/ada.png").default;
    case "USDT":
      return require("../assets/crypto/usdt.png").default;
    case "DRGN":
      return require("../assets/crypto/drgn.png").default;
    case "DOGE":
      return require("../assets/crypto/doge.png").default;
    case "TOMO":
      return require("../assets/crypto/tomo.png").default;
    case "BTMX":
      return require("../assets/crypto/btmx.png").default;
    case "TRYB":
      return require("../assets/crypto/tryb.png").default;
    case "LEO":
      return require("../assets/crypto/leo.png").default;
    case "FTT":
      return require("../assets/crypto/ftt.png").default;
    case "FTT_R3":
      return require("../assets/crypto/ftt.png").default;
    case "FTT_TT1":
      return require("../assets/crypto/ftt.png").default;
    case "FTT_TT2":
      return require("../assets/crypto/ftt.png").default;
    case "USD":
      return require("../assets/crypto/usd.png").default;
    case "EUR":
      return require("../assets/crypto/eur.png").default;
    case "BRZ":
      return require("../assets/crypto/brz.png").default;
    case "BRL":
      return require("../assets/crypto/brl.png").default;
    case "KNC":
      return require("../assets/crypto/knc.png").default;
    case "WRX":
      return require("../assets/crypto/wrx.png").default;
    case "THETA":
      return require("../assets/crypto/theta.png").default;
    case "XAUT":
      return require("../assets/crypto/xaut.png").default;
    case "COMP":
      return require("../assets/crypto/comp.svg").default;
    case "BAL":
      return require("../assets/crypto/bal.svg").default;
    case "SRM":
      return require("../assets/crypto/srm.svg").default;
    case "MSRM":
      return require("../assets/crypto/msrm.svg").default;
    case "SRM_LOCKED":
      return require("../assets/crypto/srm.svg").default;
    case "MSRM_LOCKED":
      return require("../assets/crypto/msrm.svg").default;
    case "SXP":
      return require("../assets/crypto/sxp.png").default;
    case "SOL":
      return require("../assets/crypto/sol.png").default;
    case "YFI":
      return require("../assets/crypto/yfi.svg").default;
    case "RUNE":
      return require("../assets/crypto/rune.png").default;
    case "AMPL":
      return require("../assets/crypto/ampl.png").default;
    case "WBTC":
      return require("../assets/crypto/wbtc.png").default;
    case "MKR":
      return require("../assets/crypto/mkr.png").default;
    case "DMG":
      return require("../assets/crypto/dmm.png").default;
    case "UBXT":
      return require("../assets/crypto/ubxt.png").default;
    case "UNI":
      return require("../assets/crypto/uni.png").default;
    case "AAVE":
      return require("../assets/crypto/aave.svg").default;
    case "CREAM":
      return require("../assets/crypto/cream.png").default;
    case "HGET":
      return require("../assets/crypto/hdget.png").default;
    case "HNT":
      return require("../assets/crypto/hnt.png").default;
    case "MTA":
      return require("../assets/crypto/mstable.png").default;
    case "SUSHI":
      return require("../assets/crypto/sushi.png").default;
    case "FRONT":
      return require("../assets/crypto/front.png").default;
    case "ALEPH":
      return require("../assets/crypto/aleph.png").default;
    case "OMG":
      return require("../assets/crypto/omg.png").default;
    case "AKRO":
      return require("../assets/crypto/akro.png").default;
    case "LUA":
      return require("../assets/crypto/lua.png").default;
    case "MATH":
      return require("../assets/crypto/math.png").default;
    case "HXRO":
      return require("../assets/crypto/hxro.jpg").default;
    case "KEEP":
      return require("../assets/crypto/keep.jpg").default;
    case "FIDA":
      return require("../assets/crypto/fida.svg").default;
    case "LQID":
      return require("../assets/crypto/lqid.svg").default;
    case "USDC":
      return require("../assets/crypto/usdc.svg").default;
    case "RSR":
      return require("../assets/crypto/rsr.svg").default;
    case "CEL":
      return require("../assets/crypto/cel.svg").default;
    case "PAXG":
      return require("../assets/crypto/paxg.svg").default;
    case "1INCH":
      return require("../assets/crypto/1inch.png").default;
    case "GRT":
      return require("../assets/crypto/grt.svg").default;
    case "KIN":
      return require("../assets/crypto/kin.png").default;
    case "MAPS":
      return require("../assets/crypto/maps.svg").default;
    case "PERP":
      return require("../assets/crypto/perp.png").default;
    case "RAY":
      return require("../assets/crypto/ray.svg").default;
    case "RAYPOOL":
      return require("../assets/crypto/ray.svg").default;

    // Default
    default:
      return require("../assets/crypto/other.png").default;
  }
};

export default getIcon;
